var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { announcementsList } from '../../store/static.pages.store';
import { AnnouncementsApi } from "./announcements.api";
import '../../shared/betslip/betslip.css';
import { betSlipVisibleSubject } from "../../store/betslip.store";
import { betSlipVisiblity } from "../../shared/betslip/betslip";
import { dateTimeFormat, initialLeftMenu, sportsMenu } from "../../lib/misc.functions";
import { modalServiceSubject } from '../../components/modal/modal';
export default function Announcements() {
    var _a = useState(announcementsList), announcementData = _a[0], setAnnouncementData = _a[1];
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        if (innerWidth > 968) {
            betSlipVisibleSubject.next(true);
        }
    }, []);
    useEffect(function () {
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    AnnouncementsApi.announcements()
                        .then(function (response) {
                        if (response.status == true) {
                            setAnnouncementData(response.data);
                        }
                        else {
                            modalServiceSubject.next({
                                title: "Hata!",
                                content: response.message,
                                confirm: {
                                    cancel: { label: 'Tamam' }
                                },
                                timeout: 0
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            });
        })();
    }, []);
    function selected(id) {
        var element = document.getElementById(id);
        if (element.style.display == "none") {
            element.style.display = "block";
        }
        else {
            element.style.display = "none";
        }
    }
    return (_jsx("div", __assign({ className: "announcement", style: { width: (betSlipVisiblity ? 'calc(100% - 300px)' : '100%') } }, { children: _jsxs("div", __assign({ className: "card" }, { children: [_jsx("div", __assign({ className: "card-title" }, { children: _jsx("h2", { children: "Duyurular" }, void 0) }), void 0), _jsx("div", __assign({ className: "card-body entries", style: { minHeight: '500px' } }, { children: announcementData
                        .map(function (event, key) {
                        return (event && event.id !== 979 ?
                            _jsxs("div", __assign({ onClick: function () { return selected(key); } }, { children: [_jsxs("div", __assign({ className: "d-flex align-items-center justify-content-between" }, { children: [_jsx("div", __assign({ className: "fw-bold cursor-pointer" }, { children: event.title }), void 0), event.date && _jsx("div", __assign({ className: "fw-bold cursor-pointer" }, { children: dateTimeFormat(event.date) }), void 0)] }), void 0), key == 0 ? (_jsx("div", __assign({ className: "fw-normal cursor-pointer", id: key }, { children: event.content }), void 0)) :
                                        (_jsx("div", __assign({ className: "fw-normal mt-2", style: { display: "none" }, id: key }, { children: event.content }), void 0))] }), "announcements".concat(key))
                            : null);
                    }) }), void 0)] }), void 0) }), void 0));
}
